

 
import * as THREE from "../../../../libs/three.js/build/three.module.js";
import {LineDraw} from "../../utils/DrawUtil.js";
import math  from "../../utils/math.js";
import HandleSvg from  "./HandleSvg.js";
import HandleSprite from  "./HandleSprite.js";

const sphere = new THREE.Mesh(new THREE.SphereBufferGeometry(0.08,0.08,3,2), new THREE.MeshBasicMaterial({color:'#f88'}))

 

export default class CurveCtrl extends THREE.Object3D {
    
    constructor(points, lineMat, color, name, options={}){
        super()
        this.curve = new THREE.CatmullRomCurve3(points, false, options.tension == void 0 ? "centripetal" : 'catmullrom', options.tension   )
        this.name = name || 'curveNode'
        this.handleMat = options.handleMat
        this.lineMat = lineMat
        this.createPath(); 
        this.color = color;
        this.handles = []; 
        this.wholeLength = 0 
        this.viewports = options.viewports || [viewer.mainViewport] //for HandleSprite
        for(let i=0,j=this.points.length; i<j;i++){
            this.handles.push(this.createHandle(this.points[i]))
        }   
        this.visible_ = true
        
         
        
        if(Potree.settings.isTest){   
            this.spheres = new THREE.Object3D;
            /* let i = Count+1;
            while(i>0){
                this.spheres.add(sphere.clone());
                i--;
            } */
            this.add(this.spheres)
        }
        
        this.updatePath()
        
        
    }
    
    
    addPoint(position, index, ifUpdate){
        let length = this.points.length 
        
        if(index == void 0 ){
			index = length;
		}
        
        let handle = this.createHandle(position);
         
        this.handles = [...this.handles.slice(0,index), handle, ...this.handles.slice(index,length)]
      
        this.points = [...this.points.slice(0,index), position, ...this.points.slice(index,length)]
        
        ifUpdate && (this.updatePath(), this.updateHandle(index))
    
    }
    removePoint(index){
        let handle = this.handles[index]
        handle.dispose();
        
        this.handles.splice(index,1)
        this.points.splice(index,1)
        this.updatePath()
    }
    
    createPath(){ 
   
        const line = LineDraw.createFatLine( [ ],this.lineMat)
        this.line = line;
        this.add(line);
    }
    
    
    updatePath(){ 
        this.curve.needsUpdate = true; //如果不更新，得到的点不均匀，开头点少。 
        
        let points, length = this.points.length
        
        this.wholeLength = this.points.reduce((total, currentValue, currentIndex, arr)=>{ //所有端点的距离总和
            if(currentIndex == 0)return 0
            return total + currentValue.distanceTo(arr[currentIndex-1]);
        },0)
        
        if(length > 1){ 
            const count = THREE.Math.clamp(Math.ceil(this.wholeLength * 5), 30, 500);
         
            points = this.curve.getSpacedPoints( count ); 
              
              
            if(this.needsPercent){ //获取每个节点在整条中的百分比，便于定位(但不精确)
                this.pointsPercent = [0];
                let sums = [0]
                let sum = 0, last = points[0]
                for(let i=1;i<length;i++){
                    let point = this.points[i];
                    sum += point.distanceTo(last);  //参考getLengths函数，根据长度得到百分比
                    last = point;
                    sums.push(sum) 
                }
                for(let i=1;i<length;i++){
                    this.pointsPercent.push(sum == 0 ? i/length : sums[i] / sum);
                }
                
                
            }
              
            
              
              
              
            if(Potree.settings.isTest){
                this.spheres.children.forEach(e=>e.visible = false);
                points.forEach((e,i)=>{
                    let sphere1 = this.spheres.children[i]
                    if(!sphere1){
                        sphere1 = sphere.clone();
                        this.spheres.add(sphere1);
                    }                        
                    sphere1.position.copy(e)
                    sphere1.visible = true
                })
            }
        }else{
            points = []
        } 
        
         
        LineDraw.updateLine(this.line, points)      
        
        
        this.dispatchEvent('updatePath')
        
    }
    
    
    createHandle(position){
        if(this.handleMat){
            var handle = new HandleSprite(position,  {mat:this.handleMat, viewports:this.viewports})
            this.add(handle)
        }else{
            var handle = new HandleSvg(position,  this.color)
        }
		
        handle.visible = this.visible 
        handle.addEventListener('dragged',(e)=>{
            let index = this.handles.indexOf(handle) 
            this.points[index].copy(e.position) 
            
            this.updatePath()
            
            this.dispatchEvent({type:'dragCurvePoint', index})
        })
        
        return handle
	}
    
    
    
    updateHandle(index){
        if(!this.visible)return
        
        this.handles[index].update() 
            
    }
    
    updateHandles(){
        
        this.handles.forEach((handle,index)=>{
            this.updateHandle(index) 
        }) 
    }
    
    update(){
        this.updateHandles()
        this.updatePath()
    }
    
    set visible(v){ 
        if(v != this.visible_ ){
            this.visible_ = v 
            this.visible = v 
            if(this.handles){ 
                this.handles.forEach(e=>e.visible = v  )
                if(v) this.updateHandles() //因为不可见时没更新位置
            }
        }
    }
    get visible(){
        return this.visible_
    }  
    
    
    /* set visible(v){ 
        this.handles.forEach(e=>e.svg.style.display = v ? "" : "none" )
        if(v) this.updateHandles() //因为不可见时没更新位置
    } */
    get points(){
        return this.curve.points;
    }
    set points(points){
        this.curve.points = points
    }
    getPointAt(t){
        return this.curve.getPointAt(t)
    }
    getSpacedPoints(t){
        return this.curve.getSpacedPoints(t)
    }
    dispose(){
        this.parent && this.parent.remove(this);
        
        this.handles.forEach(e=>e.dispose() )
        
        this.line.geometry && this.line.geometry.dispose()
        
    }
    
    
    
}